var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "con-btn" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeName,
              callback: function($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName"
            }
          },
          [
            _c("el-tab-pane", {
              attrs: { label: "单品式管理", name: "device" }
            }),
            _vm._v(" "),
            _c("el-tab-pane", {
              attrs: { label: "批量式管理", name: "durable" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "table-layout" }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "device",
                  expression: "activeName == 'device'"
                }
              ]
            },
            [
              _c(
                "div",
                { staticStyle: { width: "100%", "overflow-x": "auto" } },
                [
                  _c(
                    "el-form",
                    { ref: "deviceInfo", attrs: { model: _vm.scrapVoucher } },
                    [
                      _c("table", { staticClass: "custom-tbl error-prompt" }, [
                        _c("thead", { staticClass: "head" }, [
                          _c("tr", { staticClass: "row" }, [
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "180" }
                              },
                              [_vm._v("资产描述全称")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "180" }
                              },
                              [_vm._v("名称")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "150" }
                              },
                              [_vm._v("型号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "150" }
                              },
                              [_vm._v("规格")]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "250" } }, [
                              _vm._v("系统编号")
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "250" } }, [
                              _vm._v("商品标识码")
                            ]),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("分类")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("分类分组")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("品牌")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { width: "90" }
                              },
                              [_vm._v("入账方式")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("是否财务在账")]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "130" } }, [
                              _vm._v("报废部门")
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "100" } }, [
                              _vm._v("报废人")
                            ]),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "160" }
                              },
                              [_vm._v("批次号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "160" }
                              },
                              [_vm._v("资产编号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("报废")]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "80" } }, [
                              _vm._v("单位")
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "120" } }, [
                              _vm._v("报废原因")
                            ]),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("备注")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          { staticClass: "body" },
                          _vm._l(_vm.scrapVoucher.deviceItems, function(
                            deviceItem,
                            index
                          ) {
                            return _c("tr", { staticClass: "row" }, [
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(deviceItem.title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(deviceItem.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(deviceItem.model))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(deviceItem.fixedSpec))]
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(deviceItem.tmpNo))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(deviceItem.vendorUkno))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(deviceItem.catName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getGoodsCatDevcGroupName(
                                        deviceItem.catId
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(deviceItem.brandName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.acctEnterWayMap[
                                        deviceItem.acctEnterWay
                                      ]
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      deviceItem.fiscalAcctFlag == 1
                                        ? "是"
                                        : "否"
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(deviceItem.departName))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(deviceItem.staffName))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(deviceItem.batchNo))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(deviceItem.innerCode))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [_vm._v(_vm._s(deviceItem.quantity))]
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(deviceItem.theUnit))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        disabled: ""
                                      },
                                      model: {
                                        value: deviceItem.scrapCause,
                                        callback: function($$v) {
                                          _vm.$set(
                                            deviceItem,
                                            "scrapCause",
                                            $$v
                                          )
                                        },
                                        expression: "deviceItem.scrapCause"
                                      }
                                    },
                                    _vm._l(_vm.devcScrapCauseList, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.text,
                                          value: item.value
                                        }
                                      })
                                    })
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("el-input", {
                                    staticClass: "textarea-value",
                                    attrs: { type: "textarea", disabled: "" },
                                    model: {
                                      value: deviceItem.memo,
                                      callback: function($$v) {
                                        _vm.$set(deviceItem, "memo", $$v)
                                      },
                                      expression: "deviceItem.memo"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          })
                        ),
                        _vm._v(" "),
                        _c("tfoot", { staticClass: "foot" }, [
                          _vm.scrapVoucher.deviceItems == null
                            ? _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      "line-height": "40px"
                                    },
                                    attrs: { colspan: "15" }
                                  },
                                  [
                                    _c("span", { staticClass: "font-gray3" }, [
                                      _vm._v("暂无数据")
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName == "durable",
                  expression: "activeName == 'durable'"
                }
              ]
            },
            [
              _c(
                "div",
                { staticStyle: { width: "100%", "overflow-x": "auto" } },
                [
                  _c(
                    "el-form",
                    { ref: "durableInfo", attrs: { model: _vm.scrapVoucher } },
                    [
                      _c("table", { staticClass: "custom-tbl error-prompt" }, [
                        _c("thead", { staticClass: "head" }, [
                          _c("tr", { staticClass: "row" }, [
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "180" }
                              },
                              [_vm._v("资产描述全称")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "180" }
                              },
                              [_vm._v("名称")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "150" }
                              },
                              [_vm._v("型号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "150" }
                              },
                              [_vm._v("规格")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("分类")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("分类分组")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "150" }
                              },
                              [_vm._v("品牌")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "center" },
                                attrs: { width: "90" }
                              },
                              [_vm._v("入账方式")]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "130" } }, [
                              _vm._v("报废部门")
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "100" } }, [
                              _vm._v("报废人")
                            ]),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "160" }
                              },
                              [_vm._v("批次号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "160" }
                              },
                              [_vm._v("资产编号")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("在库数量")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("财务在账数量")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("可报废数量")]
                            ),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "right" },
                                attrs: { width: "100" }
                              },
                              [_vm._v("报废数量")]
                            ),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "80" } }, [
                              _vm._v("单位")
                            ]),
                            _vm._v(" "),
                            _c("th", { attrs: { width: "120" } }, [
                              _vm._v("报废原因")
                            ]),
                            _vm._v(" "),
                            _c(
                              "th",
                              {
                                staticStyle: { "text-align": "left" },
                                attrs: { width: "120" }
                              },
                              [_vm._v("备注")]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          { staticClass: "body" },
                          _vm._l(_vm.scrapVoucher.durableItems, function(
                            durableItem,
                            index
                          ) {
                            return _c("tr", { staticClass: "row" }, [
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(durableItem.title))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(durableItem.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(durableItem.model))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(durableItem.fixedSpec))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(durableItem.catName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getGoodsCatDevcGroupName(
                                        durableItem.catId
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(durableItem.brandName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "center" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.acctEnterWayMap[
                                        durableItem.acctEnterWay
                                      ]
                                    )
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(durableItem.departName))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(durableItem.staffName))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(durableItem.batchNo))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [_vm._v(_vm._s(durableItem.innerCode))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [_vm._v(_vm._s(durableItem.inStkQuantity))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [_vm._v(_vm._s(durableItem.fiscalQuantity))]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        durableItem.inStkQuantity <
                                          durableItem.fiscalQuantity -
                                            durableItem.quantity
                                          ? durableItem.inStkQuantity
                                          : durableItem.fiscalQuantity -
                                              durableItem.quantity
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "right" } },
                                [_vm._v(_vm._s(durableItem.quantity))]
                              ),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(durableItem.theUnit))]),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: {
                                        placeholder: "请选择",
                                        disabled: ""
                                      },
                                      model: {
                                        value: durableItem.scrapCause,
                                        callback: function($$v) {
                                          _vm.$set(
                                            durableItem,
                                            "scrapCause",
                                            $$v
                                          )
                                        },
                                        expression: "durableItem.scrapCause"
                                      }
                                    },
                                    _vm._l(_vm.devcScrapCauseList, function(
                                      item
                                    ) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.text,
                                          value: item.value
                                        }
                                      })
                                    })
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                { staticStyle: { "text-align": "left" } },
                                [
                                  _c("el-input", {
                                    staticClass: "textarea-value",
                                    attrs: { type: "textarea", disabled: "" },
                                    model: {
                                      value: durableItem.memo,
                                      callback: function($$v) {
                                        _vm.$set(durableItem, "memo", $$v)
                                      },
                                      expression: "durableItem.memo"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          })
                        ),
                        _vm._v(" "),
                        _c("tfoot", { staticClass: "foot" }, [
                          _vm.scrapVoucher.durableItems == null
                            ? _c("tr", [
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "text-align": "center",
                                      "line-height": "40px"
                                    },
                                    attrs: { colspan: "16" }
                                  },
                                  [
                                    _c("span", { staticClass: "font-gray3" }, [
                                      _vm._v("暂无数据")
                                    ])
                                  ]
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("资产信息")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43f72480", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43f72480","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/scrapVoucher/ShopDeviceScrapItemView.vue
// module id = 2464
// module chunks = 0